import React from 'react';

const AsyncActivityTrackerList = React.lazy(() => import('./ActivityTrackerContainer'));

export const ActivityTrackerList = () => {
  return <AsyncActivityTrackerList />;
};
